import { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

export const useStudioProfileClaimed = (studioName) => {
  const [isProfileClaimed, setIsProfileClaimed] = useState(false);
  const [claimedBy, setClaimedBy] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkStudioProfileClaimed = async () => {
      if (!studioName) {
        setLoading(false);
        return;
      }

      try {
        // Check if studio profile exists and is claimed
        const studioRef = doc(db, 'studioProfiles', studioName);
        const studioSnap = await getDoc(studioRef);
        
        if (studioSnap.exists()) {
          const studioData = studioSnap.data();
          if (studioData.claimedBy && studioData.profileClaimed) {
            setIsProfileClaimed(true);
            setClaimedBy(studioData.claimedBy);
          } else {
            setIsProfileClaimed(false);
            setClaimedBy(null);
          }
        } else {
          setIsProfileClaimed(false);
          setClaimedBy(null);
        }
      } catch (error) {
        console.error('Error checking studio profile claimed status:', error);
        setIsProfileClaimed(false);
        setClaimedBy(null);
      }
      
      setLoading(false);
    };

    checkStudioProfileClaimed();
  }, [studioName]);

  return { isProfileClaimed, claimedBy, loading };
};
